import { maxBy, minBy } from 'lodash';
import React from 'react';
import { SerpStatusGq } from '../../../../../../graphql/projects/models/SerpStatusGq';
import { TrackingData } from './TableCellDomain';

export interface RankSmallSvgProps {
  trackingValues: TrackingData[];
  rankColor?: boolean;
}

const RankSmallSvg: React.FC<RankSmallSvgProps> = ({ trackingValues, rankColor }) => {
  const svgWidth = 36;
  const svgHeight = 18;

  const minDate = minBy(trackingValues, (tv) => tv.scheduledDate.unix()).scheduledDate; // We use the scheduled time for the scale (so it's aligned)
  const minDateUnix = minDate.unix();
  const maxDate = maxBy(trackingValues, (tv) => tv.scheduledDate.unix()).scheduledDate;
  const scaleX = svgWidth / (maxDate.unix() - minDate.unix());

  const scaleY = svgHeight / 100;
  let minX: number;
  let maxX: number;
  const trackingStringLine = trackingValues
    .map((mv, index) => {
      // No line/dot if there's no tracking request for this date
      if (mv?.trackingRequest?.serpStatus !== SerpStatusGq.COMPLETED) return '';

      // Else produce line/dot
      const unixDiff = mv.scheduledDate.unix() - minDateUnix; // We use the request time for the line
      const x = unixDiff * scaleX;
      minX = minX === undefined ? x : Math.min(x, minX);
      maxX = maxX === undefined ? x : Math.max(x, maxX);
      return `${x},${(mv?.trackingRank?.rank ?? 100) * scaleY} `;
    })
    .join('');
  const trackingStringGone = trackingStringLine + `${maxX ?? svgWidth},${svgHeight} ${minX ?? 0},${svgHeight}`;

  return (
    <svg width={svgWidth} height={svgHeight} className={'overflow-visible'}>
      <polygon
        points={trackingStringGone}
        strokeWidth={0}
        stroke="none"
        className='fill-primary-200/50'
      />
      <polyline
        points={trackingStringLine}
        className={rankColor ? 'stroke-white' : 'stroke-primary-700'}
        strokeWidth={1.2}
        fill="none"
      />

    </svg>
  );
};

export default RankSmallSvg;
